export enum SelectionFieldDisplayLogic {
	show = 'show',
	showIfMoreThanOneOption = 'showIfMoreThanOneOption',
}